var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430 157"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(0 122)",
    fill: "#87284b",
    fontSize: 125,
    fontFamily: "'sofia-pro', sofia-pro-black, sans-serif",
    fontWeight: 800,
    letterSpacing: "-.024em",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search."))));
}
export default SvgSearch;